/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pm_Start_ApiInputs */

const cs_pm_start_api = /** @type {(inputs: Pm_Start_ApiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Načíst inzeráty z portálu`)
};

const en_pm_start_api = /** @type {(inputs: Pm_Start_ApiInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Load listings from the portal`)
};

/**
* | output |
* | --- |
* | "Load listings from the portal" |
*
* @param {Pm_Start_ApiInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pm_start_api = /** @type {((inputs?: Pm_Start_ApiInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pm_Start_ApiInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pm_start_api(inputs)
	return cs_pm_start_api(inputs)
});